/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
/// REACT ///
import { useEffect } from "react";
import { useState } from "react";
/// TYPES ///
import { Area } from "api/types/quote";
import { Color } from "api/types/material";
import { Material } from "api/types/material";
/// ACTIONS ///
import { updateArea } from "api/actions/quotes/area";
import { markQuoteChanged } from "api/actions/quotes/quote";
/// COMPONENTS ///
import MainColor from "components/quote/color_options/area/row/color";
/// LODASH ///
import { filter } from "lodash";
/// VALUES ///
import { QUARTZ } from "values/material";

interface Props {
  area: Area,
  description: string,
}

export default function StoreMainColorItem({ area, description }: Props) {
  const dispatch = useAppDispatch();
  const { quote } = useAppSelector(state => state.quote);
  const { colors } = useAppSelector((state) => state.dealer_material);
  const { materials } = useAppSelector((state) => state.dealer_material);
  const [filt_mats, setFiltMats] = useState<Material[]>([]);
  const [filt_colors, setFiltColors] = useState<Color[]>([]);
  const [selected_type, setSelectedType] = useState<string>(area?.material_type ?? QUARTZ);
  const [selected_material, setSelectedMaterial] = useState<number>(0);
  const [selected_color, setSelectedColor] = useState<number>(0);

  useEffect(() => {
    setSelectedType(area?.material_type);
  }, [area?.material_type]);

  useEffect(() => {
    for (let i = 0; i < materials.length; i++) {
      if (materials[i].id === area?.material) {
        setSelectedMaterial(materials[i].id);
      }
    }
  }, [materials, area?.material]);

  useEffect(() => {
    for (let i = 0; i < colors.length; i++) {
      if (colors[i].id === area?.color) {
        setSelectedColor(colors[i].id);
      }
    }
  }, [colors, area?.color]);

  useEffect(() => {
    setFiltMats(filter(materials, { "type": selected_type }));
  }, [setFiltMats, materials, selected_type]);

  useEffect(() => {
    setFiltColors(filter(colors, { "material": selected_material }));
  }, [colors, selected_material, setFiltColors]);

  const saveColor = (
    color_id: number,
    material_id: number,
    material_type: string,
    material_name: string,
    color_name: string,
    color_length: number,
    color_width: number
  ) => {
    dispatch(updateArea({
      ...area,
      color: color_id,
      material: material_id,
      material_type: material_type,
      material_name: `${material_name} ${color_name}`,
      material_length: color_length,
      material_width: color_width
    }));
    dispatch(markQuoteChanged(quote?.id));

  }

  return (
    <MainColor
      description={description}
      colors={filt_colors}
      materials={filt_mats}
      saveColor={saveColor}
      selected_type={selected_type}
      setSelectedType={setSelectedType}
      selected_material={selected_material}
      setSelectedMaterial={material => setSelectedMaterial(material.id)}
      selected_color={selected_color}
      setSelectedColor={color => setSelectedColor(color.id)}
      setCreateColorOpen={() => void 0}
      setEditColorOpen={() => void 0}
      setCreateMaterialOpen={() => void 0}
      setEditMaterialOpen={() => void 0}
      hideAdd
      hideDelete
      deleteColorOption={() => void 0} />
  );
}
